import React from 'react'
import { useDispatch } from 'react-redux'

import { DropdownItem } from '../DropdownItem'
import { isAdminDisabledInUrl } from '../../store/features/featuresService.general'
import { modalsActions } from '../../store/modals/modalsSlice'

interface Props {
  onClick: () => void
}

export const BetaFeatures: React.FC<Props> = ({ onClick }) => {
  const dispatch = useDispatch()

  if (isAdminDisabledInUrl()) {
    return null
  }

  return (
    <DropdownItem
      onClick={() => {
        onClick()
        dispatch(
          modalsActions.openModal({
            type: 'features_settings',
            openSection: 'form'
          })
        )
      }}
    >
      Beta features
    </DropdownItem>
  )
}
